import { Component, OnInit } from '@angular/core';
import { EnderecoService } from '../endereco.service';
import { Cidade } from '../models/cidade';

@Component({
  selector: 'app-cidade',
  templateUrl: './cidade.component.html',
  styleUrls: ['./cidade.component.scss']
})
export class CidadeComponent implements OnInit {

  cidades: Cidade[];
  first = 0;
  rows = 10;

  constructor(private enderecoService: EnderecoService) { }

  ngOnInit(): void {
    this.getCidades();
  }

  getCidades(){
    this.enderecoService.getCidades().subscribe(
      (res) => {
        if (res) {            
          this.cidades = res;          
        }
      },
      err => {
        console.log("ERRO CIDADE-LIST");
        console.log(err);
      }
    );
  }

  next() {
    this.first = this.first + this.rows;
}

prev() {
    this.first = this.first - this.rows;
}

reset() {
    this.first = 0;
}

isLastPage(): boolean {
    return this.cidades ? this.first === (this.cidades.length - this.rows): true;
}

isFirstPage(): boolean {
    return this.cidades ? this.first === 0 : true;
}

}
